import Cookies from 'js-cookie'

const TokenKey = 'vue_home_student_token'
const mobileSchoolKey = 'vue_home_student_manage_school'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getMobileDomain() {
  return Cookies.get(mobileSchoolKey)
}

export function setMobileDomain(domain) {
  return Cookies.set(mobileSchoolKey, domain)
}

export function removeMobileDomain() {
  return Cookies.remove(mobileSchoolKey)
}

export function getSecondDomain() {
  var domain = window.location.host
  var h = domain.split('.')[0]
  return h
}



// WEBPACK FOOTER //
// ./src/utils/auth.js